module.exports = __webpack_public_path__ + "img/moon.59c4e23f.png";